import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style.css';

const Header = () => (
	<header class={style.header}>
		<h1>Pixers</h1>
		<nav>
			<Link activeClassName={style.active} href="/">Home</Link>
			<Link activeClassName={style.active} href="/profile">GD</Link>
			<Link activeClassName={style.active} href="/drive-one">GD1</Link>
			<Link activeClassName={style.active} href="/vercel">OD</Link>
		</nav>
	</header>
);

export default Header;
